import { Vehicle } from '../../core/models';

const ActionTypes = {
  LOAD_CUSTOMER_VEHICLES: `[Vehicle] Load Customer Vehicles`,
  LOAD_CUSTOMER_VEHICLES_SUCCESS: `[Vehicle] Load Customer Vehicles Success`,
  LOAD_CUSTOMER_VEHICLES_FAIL: `[Vehicle] Load Customer Vehicles Fail`,

  UPDATE_VEHICLE_AFTER_UPDATING_ITS_INFO: `[Vehicle] Update Vehicle After Updating Its Info`,
};

export class LoadCustomerVehiclesAction {
  static type = ActionTypes.LOAD_CUSTOMER_VEHICLES;

  constructor(public payload?: any) {
  }
}
export class LoadCustomerVehiclesSuccessAction {
  static type = ActionTypes.LOAD_CUSTOMER_VEHICLES_SUCCESS;

  constructor(public payload: any) {
  }
}
export class LoadCustomerVehiclesFailAction {
  static type = ActionTypes.LOAD_CUSTOMER_VEHICLES_FAIL;

  constructor(public payload: any) {
  }
}




export class UpdateVehicleAfterUpdatingItsInfoAction {
  static type = ActionTypes.UPDATE_VEHICLE_AFTER_UPDATING_ITS_INFO;

  constructor(public payload: Partial<Vehicle>) {
  }
}
